<template>
  <v-menu v-model="menu" transition="slide-y-transition" bottom :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="menu = true" v-on="on">
            <v-icon>
              {{ settingsIcon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t(title) }}</span>
      </v-tooltip>
    </template>

    <general-settings-card v-if="setting === settingsType.GENERAL"></general-settings-card>
    <video-settings-card v-if="setting === settingsType.VIDEO"></video-settings-card>
  </v-menu>
</template>

<script>
import { mdiFolder } from '@mdi/js'
import GeneralSettingsCard from './generalSettingsCard'
import { settingsType } from '../../../enum'
import VideoSettingsCard from './videoSettingsCard'

export default {
  name: 'settingsMenu',
  components: { VideoSettingsCard, GeneralSettingsCard },
  props: {
    setting: {
      type: String,
      default: settingsType.GENERAL
    }
  },
  data: () => ({
    menu: false,
    settingsIcon: mdiFolder
  }),
  computed: {
    title () {
      switch (this.setting) {
        case settingsType.GENERAL:
          return '$vuetify.mapSettings.title'
        case settingsType.VIDEO:
          return '$vuetify.mapSettings.videoSettingsTitle'
        default:
          return '$vuetify.mapSettings.title'
      }
    }
  },
  created () {
    this['settingsType'] = settingsType
  }
}
</script>

<style scoped>

</style>
